(function () {
  const root = document.querySelector('[data-testid="product-information-media"]');
  if (!root) return;
  const only = root.dataset.showVariantMediaOnly === 'true';
  if (!only) return;

  // Wait for media gallery to render
  const observer = new MutationObserver(() => init());
  observer.observe(root, { childList: true, subtree: true });

  function init() {
    const items = Array.from(root.querySelectorAll('[data-media-id], .product__media-item, .product-media-container'));
    if (!items.length) return;
    observer.disconnect();

    function filterTo(variantId) {
      items.forEach(el => {
        const list = (el.dataset.variantIds || '').split(',').filter(Boolean);
        const show = list.length === 0 || list.includes(String(variantId));
        el.toggleAttribute('hidden', !show);
      });
    }

    function currentVariantId() {
      return document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    }

    function handleVariantChange(variantId) {
      if (!variantId) return;
      filterTo(variantId);
    }

    document.addEventListener('variant:change', e => {
      const v = e.detail?.variant?.id;
      handleVariantChange(v);
    });

    document.addEventListener('change', e => {
      if (e.target.closest('.variant-picker,[data-product-single-variant-selector]')) {
        handleVariantChange(currentVariantId());
      }
    });

    // Initial state
    const initial = currentVariantId();
    if (initial) filterTo(initial);
  }
})();
